import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';
import { paymentType, paymentMode } from '@ourbranch/lookups';

import useSession from 'core/hooks/use-session';
import { StripeCustomerIdField } from '../stripe-customer-id-field';
import useStyles from '../billing-details.styles';
import { SecondaryPaymentMethod } from '../secondary-payment-method';

const Direct = () => {
  const classes = useStyles();
  const { viewOnly } = useSession();
  const { values, setFieldValue } = useFormikContext();

  const showInvoiceNotification = [paymentType.QuarterTerm, paymentType.HalfTerm].includes(values.paymentType);

  useEffect(() => {
    if (values.paymentMode !== paymentMode.Direct) {
      setFieldValue('paymentMode', paymentMode.Direct);
    }
  }, [values?.paymentMode, setFieldValue]);

  return (
    <>
      <StripeCustomerIdField />
      <Grid container justifyContent="flex-start" className={classes.billingDetailsContainer} spacing={4}>
        {showInvoiceNotification && (
          <Grid className={classes.directBillingDescription}>
            An invoice will be sent 15 days earlier than the billing day in order to pay it before it's due.
          </Grid>
        )}
        <Grid item xs={12}>
          {!viewOnly && <SecondaryPaymentMethod />}
        </Grid>
      </Grid>
    </>
  );
};

export default observer(Direct);
